import React, {Component} from 'react';
import moment from 'moment';
import {Table} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {fullDate} from '../../../common/constants/datesFormat';

class Detail extends Component {
  renderOrders() {
    const {orders} = this.props;

    return orders.map((order, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell>{order.partCode}</Table.Cell>
          <Table.Cell>{order.partName}</Table.Cell>
          <Table.Cell textAlign='right'>{order.partQuantity}</Table.Cell>
          <Table.Cell textAlign='right'>$ {getNumericValue(order.totalFob, 2)}</Table.Cell>
          <Table.Cell>
            {order.authorizationRequest ? moment(order.authorizationRequest).format(fullDate) : ''}
          </Table.Cell>
          <Table.Cell>{order.providerName}</Table.Cell>
          <Table.Cell>
            {order.userAuthorizationRequest ? order.userAuthorizationRequest.toUpperCase() : ''}
          </Table.Cell>
          <Table.Cell>{order.authorizationDescription}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    return (
      <div className='scroll-table'>
        <Table striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Código</Table.HeaderCell>
              <Table.HeaderCell>Descripción</Table.HeaderCell>
              <Table.HeaderCell>Cantidad</Table.HeaderCell>
              <Table.HeaderCell>FOB Total</Table.HeaderCell>
              <Table.HeaderCell>Fecha</Table.HeaderCell>
              <Table.HeaderCell>Proveedor</Table.HeaderCell>
              <Table.HeaderCell>Usuario</Table.HeaderCell>
              <Table.HeaderCell>Razón del Pedido</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.renderOrders()}
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default Detail;
